import ComponentBase from "../../../public/component/component_base";
import PokerRecorderShortItem from "./poker_recorder_short_item";
import PokerRecorderDetailItem from "./poker_recorder_detail_item";
import AudioManager from "../../../../manager/audio_manager";
import AppData from "../../../public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PokerRecorder extends ComponentBase {

    @property(cc.Node)
    root: cc.Node = null

    @property(cc.Node)
    nodeShortPanel: cc.Node = null

    @property(cc.Node)
    nodeDetailPanel: cc.Node = null

    @property(PokerRecorderDetailItem)
    prefabDetailItem: PokerRecorderDetailItem = null

    @property(PokerRecorderShortItem)
    prefabShortItem: PokerRecorderShortItem = null

    @property(cc.Node)
    nodeRecordBtn: cc.Node = null

    @property(cc.Node)
    nodeShowDetailBtn: cc.Node = null

    @property(cc.Node)
    nodeHideDetailBtn: cc.Node = null

    @property(cc.Node)
    nodeShowDetailIcon: cc.Node = null

    @property(cc.Node)
    nodeHideDetailIcon: cc.Node = null

    @property(cc.Animation)
    shortPanelAnim: cc.Animation = null

    @property(cc.Animation)
    detailPanelAnim: cc.Animation = null

    @property(cc.Boolean)
    isFloat: boolean = false

    @property(cc.Size)
    btnSize: cc.Size = cc.Size.ZERO

    @property(cc.Size)
    panelSize: cc.Size = cc.Size.ZERO

    @property(cc.Float)
    maxRate: number = 0.1

    @property(cc.Float)
    delayFade: number = 4

    @property(cc.Node)
    defaultPosNode: cc.Node = null

    protected m_detailItemList: PokerRecorderDetailItem[] = []
    protected m_shortItemList: PokerRecorderShortItem[] = []

    protected m_isShortPanelShow: boolean = false
    protected m_isDetailPanelShow: boolean = false

    protected m_isBtnMoved: boolean = false
    protected m_moveOffset: cc.Vec2 = cc.Vec2.ZERO
    protected m_target_pos: cc.Vec2 = null

    onLoad() {
        this.nodeRecordBtn.on(cc.Node.EventType.TOUCH_START, this.on_touch_record_btn_start, this)
        this.nodeRecordBtn.on(cc.Node.EventType.TOUCH_MOVE, this.on_touch_record_btn_move, this)
        this.nodeRecordBtn.on(cc.Node.EventType.TOUCH_END, this.on_touch_record_btn_end, this)        
        this.nodeRecordBtn.on(cc.Node.EventType.TOUCH_CANCEL, this.on_touch_record_btn_cancel, this)        
        this.nodeShowDetailBtn.on('click', this.on_click_unfold_btn, this)
        this.nodeHideDetailBtn.on('click', this.on_click_fold_btn, this)
        cc.systemEvent.on("canvas_resize", ()=>{
            if(this && this.isValid){
                this.isFloat && this.playMoveToBorder()
            }
        })
    }

    onDestroy() {
        this.nodeRecordBtn.targetOff(this)
        this.nodeShowDetailBtn.targetOff(this)
        this.nodeHideDetailBtn.targetOff(this)
    }

    showRecord(show: boolean, showShort?: boolean, withOutDeal?: boolean) {
        this.root.active = !!show
        if(withOutDeal){
            return
        }
        if (show) {
            if(!this.m_target_pos){
                this.nodeRecordBtn.position = this.defaultPosNode.position    
            }
            if (showShort) {
                if (!this.m_isShortPanelShow) {
                    this.on_click_recorder_btn()
                }
            } else {

            }
        } else {
            this.m_isShortPanelShow = false
            this.m_isDetailPanelShow = false
            this.nodeShortPanel.active = false
            this.nodeDetailPanel.active = false
        }
    }

    protected on_touch_record_btn_start(event: cc.Event.EventTouch){
        if(!this.isFloat){
            return
        }
        this.nodeRecordBtn.stopAllActions()
        this.unscheduleAllCallbacks()
        this.nodeRecordBtn.opacity = 255
        this.m_isBtnMoved = false
        this.m_moveOffset = cc.Vec2.ZERO
    }

    protected on_touch_record_btn_move(event: cc.Event.EventTouch){
        if(!this.isFloat){
            return
        }
        if(this.m_isShortPanelShow){
            return
        }
        this.m_isBtnMoved = true
        let pos = this.nodeRecordBtn.position.clone()
        pos.x += event.getDeltaX()
        pos.y += event.getDeltaY()
        this.nodeRecordBtn.position = pos
        this.m_moveOffset.x += event.getDeltaX()
        this.m_moveOffset.y += event.getDeltaY()
    }

    protected on_touch_record_btn_end(event: cc.Event.EventTouch){
        if(!this.isFloat){
            this.on_click_recorder_btn()
            return
        }
        if(!this.m_isBtnMoved || this.m_moveOffset.mag() <= 10){
            this.on_click_recorder_btn()
            return
        }
        this.m_isBtnMoved = false        
        this.playMoveToBorder()
    }

    protected on_touch_record_btn_cancel(event: cc.Event.EventTouch){
        if(!this.isFloat){
            return
        }
        this.m_isBtnMoved = false
        this.playMoveToBorder()
    }

    protected playMoveToBorder(){
        let targetPos = this.find_suitable_btn_pos()
        this.m_target_pos = targetPos
        let duration = 0.3
        let onFinish = cc.callFunc(()=>{
            this.playFadeAnim()
        }, this)
        this.nodeRecordBtn.runAction(cc.sequence([cc.moveTo(duration, targetPos).easing(cc.easeQuinticActionOut()), onFinish])) 
    }

    protected playFadeAnim(){
        let fadeDuration = 0.3
        this.scheduleOnce(()=>{
            this.nodeRecordBtn.runAction(cc.fadeTo(fadeDuration, 255 * 0.6))
        }, this.delayFade)    
    }

    protected find_suitable_btn_pos(): cc.Vec2{
        let pos = this.nodeRecordBtn.position.clone()
        let halfHeight = AppData.designResolution.height * 0.5       
        let halfWidth =  AppData.designResolution.width * 0.5
        let dis = halfHeight - Math.abs(pos.y)
        if(dis < this.maxRate * halfHeight && dis < halfWidth - Math.abs(pos.x)){            
            if(pos.y > 0){
                pos.y = halfHeight
            }else{
                pos.y = -halfHeight
            }
        }else{
            if(pos.x >= 0){
                pos.x = halfWidth
            }else{
                pos.x = -halfWidth
            }
        }

        if(pos.y > 0){
            pos.y = Math.min(halfHeight - this.btnSize.height * 0.5, pos.y)
        }else{
            pos.y = Math.max(-halfHeight + this.btnSize.height * 0.5, pos.y)
        }

        if(pos.x > 0){
            pos.x = Math.min(halfWidth - this.btnSize.width * 0.5, pos.x)
        }else{
            pos.x = Math.max(-halfWidth + this.btnSize.width * 0.5, pos.x)
        }
        return pos
    }

    protected on_click_recorder_btn(event?) {
        this.unscheduleAllCallbacks()
        this.nodeRecordBtn.opacity = 255
        event && this.playClickSound()
        if (this.m_isShortPanelShow) {
            this.m_isShortPanelShow = false
            this.m_isDetailPanelShow = false
            this.playPanelAnim(true, this.m_isDetailPanelShow, false)
            this.nodeHideDetailBtn.active = false
            this.nodeShowDetailBtn.active = false
        } else {
            this.m_isShortPanelShow = true
            this.nodeShortPanel.active = true
            this.playPanelAnim(true, false, true)
            this.m_isDetailPanelShow = false
            this.nodeHideDetailBtn.active = false
            this.nodeShowDetailBtn.active = true
        }
    }

    protected on_click_unfold_btn() {
        this.playClickSound()
        this.m_isDetailPanelShow = true
        this.nodeShowDetailBtn.active = false
        this.nodeHideDetailBtn.active = true
        this.nodeShortPanel.active = true
        this.playPanelAnim(false, true, true)
    }

    protected on_click_fold_btn() {
        this.playClickSound()
        this.m_isDetailPanelShow = false
        this.nodeShowDetailBtn.active = true
        this.nodeHideDetailBtn.active = false
        this.playPanelAnim(false, true, false)
    }

    protected playPanelAnim(short: boolean, detail: boolean, unfold: boolean) {
        let self = this
        if(short){
            this.setDirIcon()
            this.shortPanelAnim.targetOff(this)
            this.shortPanelAnim.stop()
        }
        if(detail){
            this.detailPanelAnim.targetOff(this)
            this.detailPanelAnim.stop()
        }        

        let clipName = ''
        let panelAnim: cc.Animation = null
        let onFinish = ()=>{
            short && (self.nodeShortPanel.active = !!unfold)
            detail && (self.nodeDetailPanel.active == !!unfold)
            if(!self.nodeShortPanel.active){
                self.playFadeAnim()
            }
        }
        if (short && detail && !unfold) {
            clipName = this.getClipName(unfold, true)
            this.nodeShortPanel.active = true
            this.nodeDetailPanel.active = true
            this.shortPanelAnim.play(clipName)
            this.shortPanelAnim.on(cc.Animation.EventType.FINISHED, () => {
                clipName = this.getClipName(unfold, false)
                this.detailPanelAnim.play(clipName)
                this.shortPanelAnim.on(cc.Animation.EventType.FINISHED, onFinish)
            }, this)
        } else if (short) {
            clipName = this.getClipName(unfold, true)
            panelAnim = this.shortPanelAnim
            this.nodeShortPanel.active = true
        } else if (detail) {
            clipName = this.getClipName(unfold, false)
            panelAnim = this.detailPanelAnim
            this.nodeDetailPanel.active = true
        } else {
            return
        }
        panelAnim.play(clipName)
        panelAnim.on(cc.Animation.EventType.FINISHED, onFinish, this)        
    }

    protected setDirIcon(){
        if(this.nodeRecordBtn.y > 0){
            this.nodeShowDetailIcon.scaleY = 1
            this.nodeHideDetailIcon.scaleY = 1
        }else{
            if(AppData.designResolution.height * 0.5 + this.nodeRecordBtn.y > this.panelSize.height){
                this.nodeShowDetailIcon.scaleY = 1
                this.nodeHideDetailIcon.scaleY = 1
            }else{
                this.nodeShowDetailIcon.scaleY = -1
                this.nodeHideDetailIcon.scaleY = -1
            }
        }
    }

    protected getClipName(unfold: boolean, short: boolean): string{
        if(short){
            if(this.nodeRecordBtn.x > 0){
                return unfold? 'PokerRecorder_open1': 'PokerRecorder_close1'
            }else{
                return unfold? 'PokerRecorder_leftopen1': 'PokerRecorder_leftclose1'
            }
        }else{
            if(this.nodeRecordBtn.y > 0){
                return unfold? 'PokerRecorder_open2' : 'PokerRecorder_close2'
            }else{
                if(AppData.designResolution.height * 0.5 + this.nodeRecordBtn.y > this.panelSize.height){
                    return unfold? 'PokerRecorder_open2' : 'PokerRecorder_close2'
                }else{
                    return unfold? 'PokerRecorder_leftopen2' : 'PokerRecorder_leftclose2'
                }
            }
        }
    }

    setData(data) {
        if (this.m_shortItemList.length == 0) {
            this.initShortItems()
        }
        if (this.m_detailItemList.length == 0) {
            this.initDetailItems()
        }
        if (data.dataList) {
            this.refreshShortItems(data.dataList)
            this.refreshDetailItems(data.dataList)
        }
    }

    protected getItemConfigs() {
        return [
            { point: 1, name: 'A' },
            { point: 13, name: 'K' },
            { point: 12, name: 'Q' },
            { point: 11, name: 'J' },
            { point: 10, name: '10' },
            { point: 9, name: '9' },
            { point: 8, name: '8' },
            { point: 7, name: '7' },
            { point: 6, name: '6' },
            { point: 5, name: '5' },
            { point: 4, name: '4' },
            { point: 3, name: '3' },
            { point: 2, name: '2' },
        ]
    }

    protected initShortItems() {
        let configs = this.getItemConfigs()
        this.m_shortItemList = []
        for (let index = 0; index < configs.length; index++) {
            const config = configs[index];
            let item = this.cloneItem(this.prefabShortItem, PokerRecorderShortItem) as PokerRecorderShortItem
            item.setConfig(config)
            this.m_shortItemList.push(item)
        }
    }

    protected initDetailItems() {
        let configs = this.getItemConfigs()
        this.m_detailItemList = []
        for (let index = 0; index < configs.length; index++) {
            const config = configs[index];
            let item = this.cloneItem(this.prefabDetailItem, PokerRecorderDetailItem) as PokerRecorderDetailItem
            item.setConfig(config)
            this.m_detailItemList.push(item)
        }
    }

    protected refreshShortItems(dataList) {
        for (let i = 0; i < this.m_shortItemList.length; i++) {
            const item = this.m_shortItemList[i];
            let hasData = false
            for (let index = 0; index < dataList.length; index++) {
                const data = dataList[index];
                if (item.config.point == data.point) {
                    hasData = true
                    item.setData({ count: data.count })
                    break
                }
            }
            if (!hasData) {
                item.setData({ count: 0 })
            }
        }

    }

    protected refreshDetailItems(dataList) {
        for (let i = 0; i < this.m_detailItemList.length; i++) {
            const item = this.m_detailItemList[i];
            let hasData = false
            for (let index = 0; index < dataList.length; index++) {
                const data = dataList[index];
                if (item.config.point == data.point) {
                    hasData = true
                    item.setData({ colorCountList: data.colorCountList })
                    break
                }
            }
            if (!hasData) {
                item.setData({ colorCountList: [0, 0, 0, 0] })
            }
        }

    }

    protected cloneItem<T>(item: cc.Component, type) {
        let node = cc.instantiate(item.node)
        node.parent = item.node.parent
        node.scale = item.node.scale
        node.active = true
        let com = node.getComponent(type)
        return com
    }

    protected playClickSound() {
        AudioManager.instance.playSound('sound/public/jipaiqi')
    }
}